const UNIVERSAL = {
  // BASEURL: "http://localhost:7002/",
  BASEURL: "https://qrcodebackend-458148834331.asia-south1.run.app/",
};

export default UNIVERSAL;
